export enum SIDEMENU_ID {
  // Side Menu
  DASHBOARD = 1,
  CONFIGURATION = 2,
  EDITOR = 2,
}
